import React from 'react';
import { useTranslation } from 'react-i18next';
import Benefit from '../Benefit';
import BenefitPlaceholder from '../BenefitPlaceholder';

import s from './Benefits.scss';

export interface Props {
  benefits: string[];
  hasDiscord?: boolean;
  showPlaceholder?: boolean;
}

const Benefits: React.FC<Props> = ({
  benefits,
  hasDiscord,
  showPlaceholder,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      {hasDiscord && (
        <Benefit
          isDiscord
          benefit={t('deviationview.tierCard.benefits.discord')}
          className={s['benefit']}
        />
      )}
      {benefits.map((benefit, index) => (
        <Benefit key={index} benefit={benefit} className={s['benefit']} />
      ))}
      {showPlaceholder && benefits.length === 0 && <BenefitPlaceholder />}
    </div>
  );
};
Benefits.displayName = 'Benefits';

export default Benefits;
